<template>
    <div class="portlet" id="users" v-if="hasInstitutions">
        <div class="portlet portlet-header-only light pb-1">
            <h2 v-text="Lang.get('messages.institutions')"></h2>
        </div>

        <div class="portlet portlet-table-only light p-0">
            <table class="table table-striped table-portlet">
                <thead>
                <tr>
                    <td class="text-nowrap" style="width: 80px;">#</td>
                    <td v-text="Lang.get('messages.itemName')"></td>
                    <td></td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="institution in user.institutions">
                    <td style="width: 80px;">
                        <code v-text="institution.id"></code>
                    </td>
                    <td>
                        <a :href="'organizacia/' + institution.id + '/edit'" v-text="institution.name"></a>
                    </td>
                    <td class="text-right">
                        <button class="btn btn-default"
                                :title="Lang.get('messages.userInstitutions.unassign.title')"
                                type="button"
                                @click="unassign(institution.id)"
                                v-text="Lang.get('messages.form.cancel')">
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['user'],

        methods: {
            unassign(institutionId) {
                axios.patch('/admin/users/' + this.user.id + '/unassign', {institution_id: institutionId})
                    .then(() => {
                        flash(Lang.get('messages.userInstitutions.success', { institutionId: institutionId}));

                        axios.get('/admin/users/' + this.user.id).then(response => this.user = response.data)
                    }).catch(errors => flash(errors.response.data.message, 'danger'));
            }
        },

        computed: {
            hasInstitutions: function () {
                return (typeof this.user.institutions !== 'undefined' && this.user.institutions.length > 0);
            }
        }
    }
</script>
